import React, { useState, useEffect } from 'react';
import Footer from './Footer';
import { usePresaleListDetailsQuery, useDeleteUserMutation, useActiveRoundlistMutation } from './store/ReduxApis';
import { Link } from 'react-router-dom';
import DeleteUser from './DeleteUser';
import toast, { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import 'react-notifications/lib/notifications.css';

function PresaleRoundList() {
    const [presaleData, setPresaleData] = useState([])
    const history = useHistory();
    const presaleListData = usePresaleListDetailsQuery();
    const [createPost, responseInfo] = useActiveRoundlistMutation();

    console.log(presaleListData);

    useEffect(() => {
        setPresaleData(presaleListData?.data?.data)
    }, [presaleListData?.status === "fulfilled"])

    useEffect(() => {
        presaleListData.refetch()
    }, [])

    const updateActiveRecord = async (e, id) => {
        // e.preventDefault();
        console.log("addPresale:", id);
        await createPost({ "_id": id });
    }

    useEffect(() => {
        if (responseInfo?.data?.status === "success") {
            toast(responseInfo?.data?.message)
            presaleListData.refetch()
            // setTimeout(() => (window.location.href = '/#/presale'), 2000);
            // setTimeout(() => history.push('/presale'), 2000);
        } else if (responseInfo?.error?.data?.status === "fail") {
            toast(responseInfo?.error?.data?.message)
        }
        else if (responseInfo?.status === "fulfilled") {
            toast(responseInfo?.data?.message)
        }

    }, [responseInfo])

    return (
        <div>
            <Toaster
                toastOptions={{
                    style: {
                        fontSize: '14px',
                        padding: '10px 15px',
                        maxWidth: '300px',
                        lineHeight: '1.3',
                    },
                }}
            />
            <div class="content-wrapper">

                <section class="content-header">
                    <div class="container-fluid">

                        <div class="row mb-2">
                            <div class="col-sm-6">
                                {/* <h5>Add List</h5> */}
                            </div>
                            <div class="col-sm-6">
                                <ol class="breadcrumb float-sm-right text">
                                    <li class="breadcrumb-item"><a href="#">Home</a></li>
                                    <li class="breadcrumb-item active">Presale Round List</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </section>


                <section class="content">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h3 class="card-title"></h3>
                                        <div class="box-tools cards">
                                            <h3 style={{ fontSize: "19px" }}>Presale Round List</h3>
                                            <Link to="/add-presale">
                                                <button type="button" class="btn btn-primary pull-right addAdmin">
                                                    <i class="fa fa-plus"></i> &nbsp; Add Presale
                                                </button>
                                            </Link>

                                        </div>
                                    </div>


                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <table id="example" class="table table-bordered table-striped table-hover" datatable
                                            >
                                                <thead>
                                                    <tr className='tr'>

                                                        <th>Presale Title</th>
                                                        <th>Price (BNB)</th>
                                                        <th>Price (USDT)</th>
                                                        {/* <th>Max Amount</th> */}
                                                        {/* <th>Min Amountt</th> */}
                                                        <th>Status</th>
                                                        <th>StartDate</th>
                                                        <th>EndDate</th>
                                                        <th>Action</th>

                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {presaleData?.map(e => (
                                                        <tr className='tr'>

                                                            <td>{e.presaleTitle}</td>
                                                            <td>{e.price}</td>
                                                            <td>{e.priceinusd}</td>
                                                            {/* <td>{e.maxAmount}</td>
                                                            <td>{e.minAmount}</td> */}
                                                            <td>{e.status}</td>
                                                            <td>{e.startDate}</td>
                                                            <td>{e.endDate}</td>
                                                            <td>

                                                                {/* <Link
                                                    to={`/edit-admin/${datas.id}`}
                                                > */}
                                                                <div className='d-flex justify-content-evenly'>
                                                                    {e.hash === "" ? (
                                                                        <div>
                                                                            <span
                                                                                onClick={() => updateActiveRecord(null, e._id)}
                                                                                style={{ fontSize: "large", cursor: "pointer", color: "#72afd2" }}
                                                                                title="Start Presale"
                                                                            >
                                                                                <i className="fas fa-play"></i>
                                                                            </span>
                                                                        </div>
                                                                    ) : (
                                                                        <div style={{ width: "1.5em" }}></div>
                                                                    )}

                                                                    <Link
                                                                        to={`/edit-presale/${e._id}`}
                                                                    >
                                                                        <i class="fas fa-pen-square" style={{ fontSize: "large" }}></i>
                                                                    </Link>

                                                                    <Link
                                                                        to={`/view-presale/${e._id}`}
                                                                    >
                                                                        <i class="fa fa-eye eye" style={{ fontSize: "large" }}></i>
                                                                    </Link>
                                                                </div>

                                                            </td>

                                                        </tr>
                                                    ))}
                                                </tbody>


                                            </table>
                                        </div>
                                    </div>

                                </div>



                            </div>

                        </div>


                    </div>

                </section>
                <Footer></Footer>
            </div>
        </div>
    )
}

export default PresaleRoundList;